export default "__VITE_ASSET__19ff5d52__"